import { render, staticRenderFns } from "./layout-email-form.vue?vue&type=template&id=b494d80c&scoped=true"
import script from "./layout-email-form.vue?vue&type=script&lang=ts"
export * from "./layout-email-form.vue?vue&type=script&lang=ts"
import style0 from "./layout-email-form.vue?vue&type=style&index=0&id=b494d80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b494d80c",
  null
  
)

export default component.exports